// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1oG72","head":"ProcedureTableInfo_head__AYQkA"};